import {SYSTEM_TYPES_LIST} from "./libraryConstants";
import {getTextByValue} from "../../Utilities/Types/listUtilities";

export const getSystemTypeTextByValue = (value: string | number = "") => getTextByValue(SYSTEM_TYPES_LIST, value);
